var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Log",attrs:{"log-field":""}},[_c('v-textarea',{staticClass:"log",attrs:{"filled":"","outlined":"","readonly":"","log-text":"","rows":"20"},model:{value:(_vm.log),callback:function ($$v) {_vm.log=$$v},expression:"log"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }